/**
 * StepIndicator - Progress indicator for Bank Entry workflow steps
 */

import React from 'react';
import { cn } from '../../lib/utils';
import { CheckCircle2 } from 'lucide-react';

interface StepIndicatorProps {
  steps: string[];
  currentStep: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({ steps, currentStep }) => (
  <div className="flex items-center justify-center mb-8">
    {steps.map((step, index) => (
      <React.Fragment key={step}>
        <div className="flex items-center">
          <div className={cn(
            "w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium",
            index < currentStep
              ? "bg-green-500 text-white"
              : index === currentStep
                ? "bg-primary text-primary-foreground"
                : "bg-muted text-muted-foreground"
          )}>
            {index < currentStep ? <CheckCircle2 className="w-5 h-5" /> : index + 1}
          </div>
          <span className={cn(
            "ml-2 text-sm",
            index === currentStep ? "font-medium" : "text-muted-foreground"
          )}>
            {step}
          </span>
        </div>
        {index < steps.length - 1 && (
          <div className={cn(
            "w-12 h-0.5 mx-2",
            index < currentStep ? "bg-green-500" : "bg-muted"
          )} />
        )}
      </React.Fragment>
    ))}
  </div>
);

export default StepIndicator;
